import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

// 🔹 Section 3.1
export const fetchSection31 = createAsyncThunk(
  "gstr3b/section31",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/section-3-1", filters);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Section 3.1.1
export const fetchSection311 = createAsyncThunk(
  "gstr3b/section311",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/gstr3b/section-3-1-1", filters);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Section 3.2
export const fetchSection32 = createAsyncThunk(
  "gstr3b/section32",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/gstr3b/section-3-2", filters);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Section 4 (ITC)
export const fetchSection4 = createAsyncThunk(
  "gstr3b/section4",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/section-4", filters);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Section 5
export const fetchSection5 = createAsyncThunk(
  "gstr3b/section5",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/section-5", filters);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);